import { styled } from '@mui/material';

export const PlacePickerPlacesWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  paddingTop: 72,
  paddingBottom: 10,
});

export const PlacePickerCitiesWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  position: 'fixed',
  gap: 8,
  borderRadius: 16,
  background: '#fff',
  width: '100%',
});
